module.exports = __webpack_public_path__ + "img/mfms-icon.ed1d6a68.png";